import { type LinkWithTitle } from '@glow/shared/utils/types';

export const clientNavigationLinks: LinkWithTitle[] = [
  {
    title: 'Главная',
    link: '#home',
  },
  {
    title: 'Популярные услуги',
    link: '#popular',
  },
  {
    title: 'Почему удобно',
    link: '#why',
  },
  {
    title: 'Как пользоваться',
    link: '#how',
  },
  {
    title: 'Отличие от других',
    link: '#differences',
  },
  {
    title: 'Отзывы',
    link: '#reviews',
  },
  {
    title: 'Мастера и компании',
    link: '#recommended',
  },
  {
    title: 'FAQ',
    link: '#faq',
  },
];
